import { formatAndConvertToNumber } from './formatAndConvertToNumber';
import { roundToThree } from './roundToThree';

const exceptions = ['id', 'project_id', 'guid', 'name', 'in_edit_mode', 'comment'];
const mainKey = ['length', 'width', 'height'];
export const mainCalculations = (calculations) => {
    const { length, width, height, door_area, window_area } = calculations;

    const formattedHeight = height === '' ? '' : formatAndConvertToNumber(height);
    const formattedWidth = width === '' ? '' : formatAndConvertToNumber(width);
    const formattedLength = length === '' ? '' : formatAndConvertToNumber(length);
    const formattedDoorArea = formatAndConvertToNumber(door_area);
    const formattedWindowArea = formatAndConvertToNumber(window_area);

    const floor_area = roundToThree(formattedLength * formattedWidth);
    const ceiling_area = roundToThree(formattedLength * formattedWidth);
    const wall_area = roundToThree(2 * (formattedLength + formattedWidth) * formattedHeight);
    const perimeter = roundToThree(2 * (formattedLength + formattedWidth));
    const without_opening =
        formatAndConvertToNumber(wall_area) - formattedDoorArea - formattedWindowArea <= 0
            ? '0'
            : roundToThree(
                  formatAndConvertToNumber(wall_area) - formattedDoorArea - formattedWindowArea
              );
    const volume = roundToThree(formattedLength * formattedWidth * formattedHeight);

    const formattedCalculations = { ...calculations };

    for (let key in formattedCalculations) {
        if (formattedCalculations.hasOwnProperty(key) && !exceptions.includes(key)) {
            formattedCalculations[key] =
                mainKey.includes(key) && formattedCalculations[key] === ''
                    ? ''
                    : roundToThree(formattedCalculations[key]);
        }
    }

    return {
        ...formattedCalculations,
        floor_area,
        ceiling_area,
        wall_area,
        perimeter,
        without_opening,
        volume,
    };
};
